import {
	DismissPopupResponse,
	GetUserResponseJSON,
	PopupDismissalResponse,
	PopupKey,
} from "@performyard/service-contracts";

import request from "./internal-base-request";

export const fetchUser = async (userID: string): Promise<GetUserResponseJSON> => {
	const [response] = await request<GetUserResponseJSON>(`/v1/users/${userID}`);
	return response;
};

export const getPopupDismissed = async (popupKey: PopupKey): Promise<PopupDismissalResponse> => {
	const [response] = await request<PopupDismissalResponse>(`/v1/users/popup-dismissals/${popupKey}`);
	return response;
};

export const dismissPopup = async (popupKey: PopupKey): Promise<DismissPopupResponse> => {
	const [response] = await request<DismissPopupResponse>(`/v1/users/popup-dismissals/${popupKey}/dismiss`, {
		method: "POST",
		body: JSON.stringify({}),
	});
	return response;
};
